<template>
  <v-menu
    ref="datePicker"
    lazy
    :close-on-content-click="false"
    v-model="datePicker"
    transition="scale-transition"
    offset-y
    full-width
    :nudge-right="40"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="$t(label)"
        :value="displayField"
        :prepend-icon="isShowIcon ? 'event' : ''"
        v-on="on"
        readonly
        :rules="rule ? [dateIsRequired] : []"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :type="mode"
      :multiple="isMultiple"
      @input="selectDate"
      :max="max"
      :min="min"
    >
      <slot v-if="$slots.default"></slot>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { getBetweenDate, toPickerDateString, toDateEnd } from '@/utils/tools'
const dateMap = {
  date: 10,
  month: 7,
  year: 4
}
export default {
  name: 'datePicker',
  props: {
    value: {
      required: true,
      type: [Date, Array, String]
    },
    mode: {
      default: 'date',
      type: String
    },
    range: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'date'
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },
    dateString: {
      type: Boolean,
      default: false
    },
    max: {
      type: String,
      default: undefined
    },
    min: {
      type: String,
      default: undefined
    },
    timeZone: {
      type: String,
      default: undefined
    },
    rule: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dateSlice () {
      return dateMap[this.mode] || 10
    },
    displayField () {
      const { range, date } = this
      return range && Array.isArray(date) && date.length >= 2
        ? [date[0], date.at(-1)].join(' ~ ')
        : date
    },
    isMultiple () {
      return this.range || this.multiple
    },
    date: {
      get () {
        if (this.dateString) {
          return toPickerDateString(this.value)
        } else if (this.isMultiple) {
          const dates = this.range && this.value.length > 1
            ? getBetweenDate(this.value[0], this.value.at(-1))
            : this.value
          return dates.map(date => this.formatDate(date).slice(0, this.dateSlice))
        } else {
          return this.formatDate(this.value).slice(0, this.dateSlice)
        }
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      datePicker: false
    }
  },
  methods: {
    dateIsRequired () {
      let v = this.date
      const errorMsg = this.$t('fieldIsRequired', { fieldName: 'This field' })
      if (this.range) {
        return (Array.isArray(v) && v.length >= 2) || errorMsg
      }
      if (v !== undefined && v !== null && typeof v === 'string') v = v.trim()
      return (!!v && JSON.stringify(v) !== '{}') || v === 0 || errorMsg
    },
    toLocalDateString (date) {
      date = toDateEnd(date)
      let tzoffset = date.getTimezoneOffset() * 60000 // offset in milliseconds
      let localISOTime = new Date(date - tzoffset)
      return localISOTime
    },
    formatDate (date) {
      if (this.timeZone !== 'UTC') {
        return date.toISOString()
      }
      return this.toLocalDateString(date).toISOString()
    },
    sortData (data) {
      return [...data].sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
    },
    selectDate (value) {
      if (this.range) {
        const valueLen = value.length
        const selectDatesLen = this.date.length
        let targetDate = ''
        if (valueLen > selectDatesLen) {
          targetDate = value[valueLen - 1]
        } else if (valueLen < selectDatesLen) {
          targetDate = this.date.find(date => !value.includes(date))
        }
        const lastVal = value[valueLen - 1]
        const data = selectDatesLen === 1
          ? targetDate === this.date[0]
            ? [this.date[0], this.date[0]]
            : this.sortData([value[0], lastVal])
          : [targetDate]
        this.date = data.map((date, i) => new Date(`${date}T${i === 0 ? '00:00:00.000Z' : '23:59:59.999Z'}`))
        if (data.length >= 2) {
          this.datePicker = false
        }
      } else if (this.multiple) {
        this.date = value.map(date => new Date(date))
      } else if (this.dateString) {
        this.datePicker = false
      } else {
        this.date = new Date(value)
        this.datePicker = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DatePicker.vue